import Link from "next/link";

export type CtaAction = {
  href: string;
  label: string;
  primary?: boolean;
  /** Метка для сквозной аналитики кликов, попадает в data-cta-location. */
  ctaLocation?: string;
};

function isExternalHref(href: string): boolean {
  return /^(https?:)?\/\//i.test(href);
}

/**
 * Единая кнопка CTA: primary — белая, secondary — контурная. Внешние ссылки
 * открываются в новой вкладке, якоря и mailto/tel остаются обычными ссылками,
 * остальное — клиентская навигация Next.
 */
export default function SmartCtaLink({ href, label, primary, ctaLocation }: CtaAction) {
  const className = primary
    ? "inline-flex items-center rounded-full bg-white px-4 py-2 text-sm font-semibold text-[#202e64] transition-opacity hover:opacity-90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/60"
    : "inline-flex items-center rounded-full border border-white/20 px-4 py-2 text-sm text-white/80 transition-colors hover:border-white/40 hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/60";
  const dataAttrs = ctaLocation ? { "data-cta-location": ctaLocation } : {};

  if (isExternalHref(href)) {
    return (
      <a href={href} target="_blank" rel="noopener noreferrer" className={className} {...dataAttrs}>
        {label}
      </a>
    );
  }
  if (href.startsWith("#") || href.startsWith("mailto:") || href.startsWith("tel:")) {
    return (
      <a href={href} className={className} {...dataAttrs}>
        {label}
      </a>
    );
  }
  return (
    <Link href={href} className={className} {...dataAttrs}>
      {label}
    </Link>
  );
}
